import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import App from './App';
import store from './store/index';
import './i18t';
import ThemeProvider from 'theme/ThemeProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const consoleError = console.error.bind(console);

console.error = (...args) => {
  const msg = args
    .map(a => (typeof a === 'string' ? a : ''))
    .join(' ');

  if (msg.includes('findDOMNode')) return;

  consoleError(...args);
};

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);
